import { ComponentProps } from 'react';

import moment from 'moment';
import { useIntl } from 'react-intl';

import {
  FullCalendar,
  dayGridPlugin,
  interactionPlugin,
  momentPlugin,
} from 'lib/fullcalendar';
import { format } from 'utils';

import { texts } from './Calendar.text';

import styles from './Calendar.module.scss';

export type CalendarProps = {} & Omit<
  ComponentProps<typeof FullCalendar>,
  | 'plugins'
  | 'initialView'
  | 'locale'
  | 'firstDay'
  | 'headerToolbar'
  | 'selectable'
  | 'selectAllow'
  | 'buttonIcons'
  | 'buttonText'
>;

export const Calendar = (props: CalendarProps) => {
  const { formatMessage } = useIntl();

  return (
    <div className={styles.root}>
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin, momentPlugin]}
        initialView="dayGridMonth"
        locale="sv"
        firstDay={1}
        headerToolbar={{
          start: 'prev',
          center: 'title',
          end: 'next',
        }}
        selectable
        selectAllow={({ startStr, endStr }) => {
          const start = format.date({ date: startStr });
          const end = format.date({ date: endStr });
          const duration = moment.duration(end.diff(start)).asDays();
          return duration === 1;
        }}
        buttonIcons={false}
        buttonText={{
          prev: formatMessage(texts.buttonTextPrev),
          next: formatMessage(texts.buttonTextNext),
        }}
        {...props}
      />
    </div>
  );
};
